<template>
  <div :class="style['title-block']">
    <h4 :class="style.title" v-html="slide.title"></h4>
    <a :class="style.link" v-theme-font v-if="slide.detail_info && slide.detail_info.url" :href="slide.detail_info.url" target="_blank">{{slide.detail_info.text}} ></a>
  </div>
</template>

<script>
import style from './scss/_slider.scss'

export default {
  props: {
    slide: {
      type: Object,
      required: true
    }
  },
  computed: {
    style: () => style
  }
}
</script>
